import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditGruposActividadTallerV11Component } from "./edit-grupos-actividad-taller-v11/edit-grupos-actividad-taller-v11.component";

@Component({
  selector: "app-grupos-actividad-taller-v11",
  templateUrl: "./grupos-actividad-taller-v11.component.html",
  styleUrls: ["./grupos-actividad-taller-v11.component.scss"],
})
export class GruposActividadTallerV11Component extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditGruposActividadTallerV11Component;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
